import { render, staticRenderFns } from "./zenga-new-flats.vue?vue&type=template&id=d784fbba&scoped=true&lang=pug"
import script from "./zenga-new-flats.vue?vue&type=script&setup=true&lang=js"
export * from "./zenga-new-flats.vue?vue&type=script&setup=true&lang=js"
import style0 from "./zenga-new-flats.vue?vue&type=style&index=0&id=d784fbba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d784fbba",
  null
  
)

export default component.exports